import React, { useEffect, useState } from 'react'
import './user-info.css'
import { AppUseSelector } from '../../../redux/hooks'
import { getCurrentStreak } from '../../../redux/actions/streakAction'
import { StreakIcon } from 'containers/icons/icons'
import { useNavigate } from 'react-router-dom'
import posthog from 'posthog-js'
import { useTranslation } from 'react-i18next'
import { HISTORY } from 'routes/routeConstant'
import 'components/stories/history.css'
const UserInfo = ({ title }) => {
  const { t } = useTranslation('landing')
  const navigate = useNavigate()
  const { credentials } = AppUseSelector(({ user }) => user)
  const { storiesListLoader } = AppUseSelector(({ story }) => story)
  const { current } = AppUseSelector(({ streak }) => streak)
  const { customFields, metaData } = credentials
  const [streakCount, setStreakCount] = useState<string[]>([])
  const username = customFields?.['first-name'] || metaData?.firstName

  useEffect(() => {
    getCurrentStreak()
  }, [])

  useEffect(() => {
    if (current) {
      setStreakCount(getStreak(current?.counter))
    }
  }, [current])

  const getStreak = (count: number) => {
    if (count > 3) {
      return ['#E47D5D', '#E47D5D', '#E47D5D']
    }
    switch (count) {
      case 0:
        return ['#B6B6B6', '#B6B6B6', '#B6B6B6']
      case 1:
        return ['#B6B6B6', '#B6B6B6', '#E47D5D']
      case 2:
        return ['#B6B6B6', '#E47D5D', '#E47D5D']
      case 3:
        return ['#E47D5D', '#E47D5D', '#E47D5D']
      default:
        return ['#B6B6B6', '#B6B6B6', '#B6B6B6']
    }
  }

  return (
    <div>
      {storiesListLoader ? (
        <div className='user_info_skeleton_loader'>
          <div className='user_info_skeleton_left'></div>
          <div className='user_info_skeleton_right'></div>
        </div>
      ) : (
        (username || title || streakCount?.length || current?.counter) && (
          <div className='user_info_main_div'>
            <h6>
              <span className='fw-700'>{username ? t('userInfo.greeting', { name: username }) : ''}</span> {title || null}
            </h6>
            <div className='d-flex align-items-center'>
              {!!streakCount?.length && (
                <div className='d-flex align-items-center'>
                  <div className='d-flex'>{streakCount?.map((streak, i) => <StreakIcon color={streak} key={i} />)}</div>
                  <p className='days_text'>{t('userInfo.streak', { count: current?.counter ?? 0 })}</p>
                </div>
              )}
              {/* Same entry point as the clock icon on the apps' home screen. */}
              <button
                type='button'
                className='history-icon-btn'
                title={t('userInfo.pastLessons')}
                aria-label={t('userInfo.pastLessons')}
                onClick={() => {
                  posthog.capture('story_history_opened', { source: 'stories_icon' })
                  navigate(HISTORY)
                }}
              >
                <i className='fa fa-history' aria-hidden='true' />
              </button>
            </div>
          </div>
        )
      )}
    </div>
  )
}

export default UserInfo
